export const states = [
  {
    label: 'AK',
    longLabel: 'Alaska',
    y: 8,
    x: 1,
  },
  {
    label: 'ME',
    longLabel: 'Maine',
    y: 8,
    x: 11,
  },
  {
    label: 'VT',
    longLabel: 'Vermont',
    y: 7,
    x: 10,
  },
  {
    label: 'NH',
    longLabel: 'New Hampshire',
    y: 7,
    x: 11,
  },
  {
    label: 'WA',
    longLabel: 'Washington',
    y: 6,
    x: 1,
  },
  {
    label: 'ID',
    longLabel: 'Idaho',
    y: 6,
    x: 2,
  },
  {
    label: 'MT',
    longLabel: 'Montana',
    y: 6,
    x: 3,
  },
  {
    label: 'ND',
    longLabel: 'North Dakota',
    y: 6,
    x: 4,
  },
  {
    label: 'MN',
    longLabel: 'Minnesota',
    y: 6,
    x: 5,
  },
  {
    label: 'IL',
    longLabel: 'Illinois',
    y: 6,
    x: 6,
  },
  {
    label: 'WI',
    longLabel: 'Wisconsin',
    y: 6,
    x: 7,
  },
  {
    label: 'MI',
    longLabel: 'Michigan',
    y: 6,
    x: 8,
  },
  {
    label: 'NY',
    longLabel: 'New York',
    y: 6,
    x: 9,
  },
  {
    label: 'RI',
    longLabel: 'Rhode Island',
    y: 6,
    x: 10,
  },
  {
    label: 'MA',
    longLabel: 'Massachusetts',
    y: 6,
    x: 11,
  },
  {
    label: 'OR',
    longLabel: 'Oregon',
    y: 5,
    x: 1,
  },
  {
    label: 'NV',
    longLabel: 'Nevada',
    y: 5,
    x: 2,
  },
  {
    label: 'WY',
    longLabel: 'Wyoming',
    y: 5,
    x: 3,
  },
  {
    label: 'SD',
    longLabel: 'South Dakota',
    y: 5,
    x: 4,
  },
  {
    label: 'IA',
    longLabel: 'Iowa',
    y: 5,
    x: 5,
  },
  {
    label: 'IN',
    longLabel: 'Indiana',
    y: 5,
    x: 6,
  },
  {
    label: 'OH',
    longLabel: 'Ohio',
    y: 5,
    x: 7,
  },
  {
    label: 'PA',
    longLabel: 'Pennsylvania',
    y: 5,
    x: 8,
  },
  {
    label: 'NJ',
    longLabel: 'New Jersey',
    y: 5,
    x: 9,
  },
  {
    label: 'CT',
    longLabel: 'Connecticut',
    y: 5,
    x: 10,
  },
  {
    label: 'CA',
    longLabel: 'California',
    y: 4,
    x: 1,
  },
  {
    label: 'UT',
    longLabel: 'Utah',
    y: 4,
    x: 2,
  },
  {
    label: 'CO',
    longLabel: 'Colorado',
    y: 4,
    x: 3,
  },
  {
    label: 'NE',
    longLabel: 'Nebraska',
    y: 4,
    x: 4,
  },
  {
    label: 'MO',
    longLabel: 'Missouri',
    y: 4,
    x: 5,
  },
  {
    label: 'KY',
    longLabel: 'Kentucky',
    y: 4,
    x: 6,
  },
  {
    label: 'WV',
    longLabel: 'West Virginia',
    y: 4,
    x: 7,
  },
  {
    label: 'VA',
    longLabel: 'Virginia',
    y: 4,
    x: 8,
  },
  {
    label: 'DE',
    longLabel: 'Delaware',
    y: 4,
    x: 9,
  },
  {
    label: 'AZ',
    longLabel: 'Arizona',
    y: 3,
    x: 2,
  },
  {
    label: 'NM',
    longLabel: 'New Mexico',
    y: 3,
    x: 3,
  },
  {
    label: 'KS',
    longLabel: 'Kansas',
    y: 3,
    x: 4,
  },
  {
    label: 'AR',
    longLabel: 'Arkansas',
    y: 3,
    x: 5,
  },
  {
    label: 'TN',
    longLabel: 'Tennessee',
    y: 3,
    x: 6,
  },
  {
    label: 'NC',
    longLabel: 'North Carolina',
    y: 3,
    x: 7,
  },
  {
    label: 'SC',
    longLabel: 'South Carolina',
    y: 3,
    x: 8,
  },
  {
    label: 'MD',
    longLabel: 'Maryland',
    y: 3,
    x: 9,
  },
  {
    label: 'HI',
    longLabel: 'Hawaii',
    y: 2,
    x: 1,
  },
  {
    label: 'OK',
    longLabel: 'Oklahoma',
    y: 2,
    x: 4,
  },
  {
    label: 'LA',
    longLabel: 'Louisiana',
    y: 2,
    x: 5,
  },
  {
    label: 'MS',
    longLabel: 'Mississippi',
    y: 2,
    x: 6,
  },
  {
    label: 'AL',
    longLabel: 'Alabama',
    y: 2,
    x: 7,
  },
  {
    label: 'GA',
    longLabel: 'Georgia',
    y: 2,
    x: 8,
  },
  {
    label: 'TX',
    longLabel: 'Texas',
    y: 1,
    x: 4,
  },
  {
    label: 'FL',
    longLabel: 'Florida',
    y: 1,
    x: 9,
  },
];
